<script>
import { mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import { fetchFaq, createFaq, updateFaq, fetchFaqTypes } from '@apis/admin/cs'
import fromPairs from 'lodash/fromPairs'
import LangItem from '@components/admin/lang-input'
import defaults from 'lodash/defaults'

export default {
  components: { LangItem },
  props: {
    faq_seq: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      info: {},
      params: {},
      faq_types: [],
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },

  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadInfo(), this.loadFaqTypes()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadInfo() {
      const { faq_info } = await fetchFaq(this.faq_seq)
      this.params = defaults(faq_info, {
        type_seq: 0,
        title: '',
        content: '',
      })

      this.info = faq_info
    },
    async loadFaqTypes() {
      const { data } = await fetchFaqTypes()
      this.faq_types = data
    },
    handleSubmit() {
      const createOrUpdate = !this.faq_seq ? createFaq : updateFaq
      const confirm_message = this.faq_seq
        ? this.$t('cs_faq.modify')
        : this.$t('cs_faq.register')
      const success_message = this.faq_seq
        ? this.$t('cs_faq.msg_cs_modify')
        : this.$t('cs_faq.msg_cs_register')
      if (this.faq_seq) {
        this.params.seq = this.faq_seq
      }
      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <div v-loading="loading">
    <h3 :class="$style.xeAdmin">{{ $t('cs_faq.cs_info') }}</h3>
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="150" />
        <col width="*" />
        <col width="150" />
        <col width="*" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"
            ><div>{{ $t('cs_faq.cs_type') }}</div></th
          >
          <td>
            <select
              v-model="params.type_seq"
              :disabled="Boolean(info && info.type_Seq)"
            >
              <option :value="0">{{ $t('cs_faq.type_selete') }}</option>
              <option
                v-for="{ seq, title } in faq_types"
                :key="seq"
                :value="seq"
                >{{ title }}</option
              >
            </select>
          </td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('cs_faq.title') }}</div></th
          >
          <td>
            <LangItem v-if="!loading" v-model="params.title"></LangItem>
          </td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('cs_faq.content') }}</div></th
          >
          <td>
            <LangItem v-if="!loading" v-model="params.content"></LangItem>
          </td>
        </tr>

        <tr>
          <th colspan="4" :class="$style.button">
            <a
              :class="[$style.button, $style.black]"
              @click.prevent="handleSubmit"
              ><span>{{
                faq_seq ? $t('cs_faq.modify') : $t('cs_faq.register')
              }}</span></a
            >
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
